// import ProductService from '@/services/ProductService.js'
// export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

import OrderService from "@/services/OrderService"
import ShippingService from "@/services/ShippingService"

export const state = {
    rate: {}
}

export const mutations = {
    SET_RATE(state, rate) {
        state.rate = rate
    }
}

export const namespaced = true

export const actions = {
  upsertOrder({ dispatch }, orderBody) {
    return OrderService.upsertOrder(orderBody)
        .then((response) => {
            const notification = {
                type: 'success',
                message: 'Your new order has been added successfully!'
            }
            dispatch('notification/add', notification, { root: true })
            return response.data
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem adding your order: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
        })
  },

  fetchReviewDetails({ dispatch }) {
    return OrderService.fetchReview()
        .then((response) => {
            const notification = {
                type: 'success',
                message: 'Your review data fetched successfully!'
            }
            dispatch('notification/add', notification, { root: true })
            return response.data ? response.data.status : false;
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem fetching review data: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
        })
  },

  saveReviewDetails({ dispatch }, reviewJson) {
    return OrderService.saveReview(reviewJson)
        .then((response) => {
            const notification = {
                type: 'success',
                message: 'Your review data added successfully!'
            }
            dispatch('notification/add', notification, { root: true })
            return response.data;
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem adding review data: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
        })
  },

  getShippingRates({commit, dispatch}, cartId) {
    return ShippingService.getShippingRates(cartId)
        .then((response) => {
            const notification = {
                type: 'success',
                message: 'Your shipping rates fetched successfully!'
            }
            dispatch('notification/add', notification, { root: true })
            commit('SET_RATE', response.data)
            return response.data;
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: 'There was a problem fetching shipping rates: ' + error.message
            }
            dispatch('notification/add', notification, { root: true })
            throw error
        })
  }
}

export const getters = {}
